// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-container {
  background-color: #F8FAFC;
  border-right: 1px solid #E2E8F0;
}

.sidebar-list {
  margin: 0.75rem 0;
  padding-left: 1.25rem;
  list-style-type: disc;
}

.sidebar-list li {
  margin: 0.5rem 0;
  color: #16191F;
}

/* Mobile responsiveness - hide sidebar on small screens */
@media (max-width: 768px) {
  .sidebar-container {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/Sidebar.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,0DAA0D;AAC1D;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".sidebar-container {\n  background-color: #F8FAFC;\n  border-right: 1px solid #E2E8F0;\n}\n\n.sidebar-list {\n  margin: 0.75rem 0;\n  padding-left: 1.25rem;\n  list-style-type: disc;\n}\n\n.sidebar-list li {\n  margin: 0.5rem 0;\n  color: #16191F;\n}\n\n/* Mobile responsiveness - hide sidebar on small screens */\n@media (max-width: 768px) {\n  .sidebar-container {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
